/**
 * MOP 首屏轮播图设置 id 与槽位数；与 RBP2、首屏骨架卡位数量一致。
 */
export const MOP_CAROUSEL_SETTING_KEYS = [56, 57, 58, 59, 60] as const;
